import fabric from './fabric_with_gestures';

export default fabric;